The list of events that were attempted to be delivered in the request body.
